@let assignmentData = assignment();
@let showP3 = showP3Fields();

@if (!hideHeading()) {
	<h3>{{ 'assignment.details.title' | transloco }}</h3>
}
<table>
	<tr>
		<th>{{ 'assignment.details.contact_phase_start' | transloco }}:</th>
		<th>
			@if (!hideConsultationDate()) {
				{{ 'assignment.details.consultation_start' | transloco }}:
			}
		</th>
	</tr>
	<tr>
		<td>{{ contactPhaseStart() ? (contactPhaseStart() | date: dateDisplayFormat) : '-' }}</td>
		<td>
			@if (!hideConsultationDate()) {
				{{ assignmentData.consultationDate ? (assignmentData.consultationDate | date: dateDisplayFormat) : '-' }}
			}
		</td>
	</tr>

	@if (showRequiredLegalBaseInP2()) {
		<tr>
			<th>{{ 'assignment.details.type_of_care' | transloco }}:</th>
			@if (showCaseGroup()) {
				<th>{{ 'assignment.details.case_group' | transloco }}:</th>
			} @else {
				<th aria-hidden="true"></th>
			}
		</tr>
		<tr>
			<td>{{ assignmentData.typeOfCare?.remark ?? '-' }}</td>
			@if (showCaseGroup()) {
				<td>{{ assignmentData.caseGroup?.description ?? '-' }}</td>
			} @else {
				<td aria-hidden="true"></td>
			}
		</tr>
		<tr>
			<th>{{ 'assignment.details.sponsor' | transloco }}:</th>
			<th>{{ 'assignment.details.legal_foundation' | transloco }}:</th>
		</tr>
		<tr>
			<td>{{ assignmentData.sponsor?.name ?? '-' }}</td>
			<td>{{ assignmentData.legalFoundation?.description ?? '-' }}</td>
		</tr>
	}

	@if (showCareRelatedDisabilityTypeInP2()) {
		<tr>
			<th>{{ 'assignment.details.care_related_disability_type' | transloco }}:</th>
			<th aria-hidden="true"></th>
		</tr>
		<tr>
			<td>{{ assignmentData.careRelatedHandicap?.disabilityType?.remark ?? '-' }}</td>
			<td aria-hidden="true"></td>
		</tr>
	}

	@if (showP3) {
		<tr>
			<th>{{ 'assignment.details.care_start' | transloco }}:</th>
			@if (showCaseGroup()) {
				<th>{{ 'assignment.details.case_group' | transloco }}:</th>
			} @else {
				<th aria-hidden="true"></th>
			}
		</tr>
		<tr>
			<td>{{ assignmentData.careStartDate ? (assignmentData.careStartDate | date: dateDisplayFormat) : '-' }}</td>
			@if (showCaseGroup()) {
				<td>{{ assignmentData.caseGroup?.description ?? '-' }}</td>
			} @else {
				<td aria-hidden="true"></td>
			}
		</tr>
		<tr>
			<th>{{ 'assignment.details.care_related_disability_type' | transloco }}:</th>
			<th>{{ 'assignment.details.type_of_care' | transloco }}:</th>
		</tr>
		<tr>
			<td>{{ assignmentData.careRelatedHandicap?.disabilityType?.remark }}</td>
			<td>{{ assignmentData.typeOfCare?.remark ?? '-' }}</td>
		</tr>
		<tr>
			<th>{{ 'assignment.details.sponsor' | transloco }}:</th>
			<th>{{ 'assignment.details.legal_foundation' | transloco }}:</th>
		</tr>
		<tr>
			<td>{{ assignmentData.sponsor?.name ?? '-' }}</td>
			<td>{{ assignmentData.legalFoundation?.description ?? '-' }}</td>
		</tr>
	}

	<tr>
		<th>{{ 'assignment.details.initiator' | transloco }}:</th>
		<th>{{ 'assignment.details.social_data_protection_info' | transloco }}:</th>
	</tr>
	<tr>
		<td>
			{{ initiator() }}
		</td>
		<td>
			{{
				(assignmentData.hasBeenClarified || assignmentData.socialDataProtectionInfo
					? 'assignment.privacy.yes'
					: 'assignment.privacy.no'
				) | transloco
			}}<br />
			{{ assignmentData.clarifiedAt | date: dateDisplayFormat }}<br />
			{{ getClarificationLabel(assignmentData.typeOfClarification) }}
		</td>
	</tr>
	<tr>
		<th>{{ 'assignment.details.current_phase_start' | transloco }}:</th>
		<th>{{ 'assignment.details.newest_contact_date' | transloco }}:</th>
	</tr>
	<tr>
		<td>
			{{ assignmentPhaseStartDate() ? (assignmentPhaseStartDate() | date: dateDisplayFormat) : '-' }}
		</td>
		<td>{{ latestContact() ? (latestContact() | date: dateDisplayFormat) : '-' }}</td>
	</tr>

	@if (!isAssignmentInP1() || showP3) {
		<tr>
			@if (!isAssignmentInP1()) {
				<th>{{ 'assignment.details.impediment_due_date' | transloco }}</th>
			}

			@if (showP3) {
				<th>{{ 'assignment.details.unemployability_since' | transloco }}:</th>
			}
		</tr>
		<tr>
			@if (!isAssignmentInP1()) {
				<td>
					{{
						assignmentData.impedimentReportDueDate
							? (assignmentData.impedimentReportDueDate | date: dateDisplayFormat)
							: '-'
					}}
				</td>
			}
			@if (showP3) {
				<td>
					{{
						assignmentData.unemployabilitySince ? (assignmentData.unemployabilitySince | date: dateDisplayFormat) : '-'
					}}
				</td>
			}
		</tr>
	}
	@if (canReadAssignmentDocuments() || showP4Fields()) {
		<tr>
			@if (canReadAssignmentDocuments()) {
				<th>{{ 'assignment.details.documents' | transloco }}:</th>
			} @else {
				<th aria-hidden="true"></th>
			}

			@if (showP4Fields()) {
				<th>{{ 'assignment.details.cancellation_date' | transloco }}:</th>
			} @else {
				<th>{{ 'user.assignment_transfer.assignment_number' | transloco }}:</th>
			}
		</tr>
		<tr>
			@if (canReadAssignmentDocuments()) {
				<td>
					<ul>
						@for (doc of assignmentData.documents; track doc.id) {
							<li>
								<lvr-document-item [document]="buildDocumentEntryFromAssignment(doc)" (open)="onFileClick(doc)">
								</lvr-document-item>
							</li>
						}
					</ul>
				</td>
			} @else {
				<td aria-hidden="true"></td>
			}

			@if (showP4Fields()) {
				<td>
					{{ assignment().cancellationDate ? (assignment().cancellationDate | date: dateDisplayFormat) : '-' }}
				</td>
			} @else {
				<td>{{ assignmentData.guid }}</td>
			}
		</tr>
		@if (showP4Fields()) {
			<tr>
				<th>{{ 'user.assignment_transfer.assignment_number' | transloco }}:</th>
			</tr>
			<tr>
				<td>{{ assignmentData.guid }}</td>
			</tr>
		}
	} @else {
		<tr>
			<th aria-hidden="true"></th>
			<th>{{ 'user.assignment_transfer.assignment_number' | transloco }}:</th>
		</tr>
		<tr>
			<td aria-hidden="true"></td>
			<td>{{ assignmentData.guid }}</td>
		</tr>
	}
</table>
